module.exports = __webpack_public_path__ + "static/media/profilePic.37aed63b.jpg";